import { useEffect, useState } from 'react'
import { client } from '../graphql/client'
import { SEARCH_MERCHANTS_BY_PID, SEARCH_SELECTOR_MERCHANTS } from '../graphql/queries/merchantQueries'

export const useMerchantSearch = ({ value, country, pidMode, enabled }) => {
	const [result, setResult] = useState(null)
	const searchValue = pidMode ? value.trim() : value
	const searchCountry = country
	const key = JSON.stringify([searchValue, searchCountry, pidMode, enabled])

	useEffect(() => {
		if (!enabled || !searchValue.trim()) return

		let active = true
		const timer = setTimeout(async () => {
			try {
				const { data } = await client.query({
					query: pidMode ? SEARCH_MERCHANTS_BY_PID : SEARCH_SELECTOR_MERCHANTS,
					variables: pidMode
						? { countryCode: searchCountry, pids: [searchValue] }
						: { value: searchValue, country: searchCountry },
				})
				if (!active) return

				const lookup = pidMode ? data.merchantsByPids[0] : null
				const merchants = pidMode
					? lookup?.status === 'FOUND' && lookup.merchant
						? [lookup.merchant]
						: []
					: data.merchants
				setResult({ key, merchantList: merchants.map(merchant => ({ merchant })), status: lookup?.status, error: null })
			} catch (error) {
				if (active) setResult({ key, merchantList: null, error })
			}
		}, 200)

		return () => {
			active = false
			clearTimeout(timer)
		}
	}, [key, searchValue, searchCountry, pidMode, enabled])

	return result?.key === key ? result : { merchantList: null, error: null, status: null }
}
